import { useCallback, useMemo } from "react";

import { ILogger } from "@ezhou/common";
import { PageProps } from "@ezhou/core";
import { IItemProps } from "devextreme-react/form";

import { SaveChangeResult } from "../../components/dataGridActionUtil";
import { CrudDataGrid } from "../common/CrudDataGrid";
import { armMappingDimensionValueColumns, dummyArmMappingDimensionValueRow } from "./model/metaData";
import { AmrMappingDimension } from "./model/model";

type ArmMappingDimensionValuesProps = {
  pageProps: PageProps;
  logger: ILogger;
  mappingDimension: AmrMappingDimension;
  availableValues?: string[];
};

export const ArmMappingDimensionValues = (props: ArmMappingDimensionValuesProps) => {
  props.logger.debug("Rendering ArmMappingDimensionValues");
  const refreshValueData = useCallback(async () => {
    if (!props.mappingDimension) {
      return [];
    }
    return props.mappingDimension.values;
  }, [props.mappingDimension]);

  const filterValueRowDataForForm = (data: any) => {
    return data;
  };

  const sendValueChange = async (change: {
    type: any;
    data: any;
    key: any;
  }): Promise<SaveChangeResult> => {
    switch (change.type) {    
      case "insert":
        //Somehow, need this line to change props.mappingDimension.values array
        //This will cause duplicate key exception thrown in dataGridRreducer SAVING_SUCCESS applyChanges
        //After further investigation, in dataGridRreducer SAVING_SUCCESS, state.data is not changed, instead,
        //it is used to combine with new added row to form newData, then newData is used to generate new state.
        //After that crudDataGrid's state is not binded to props.mappingDimension.values anymore.
        //So, only first insert will cause duplicate key exception.
        props.mappingDimension.values.push(change.data);
        break;
      case "remove":
        const index = props.mappingDimension.values
          .findIndex(item => item.value === change.key);
        if (index > -1) {
          props.mappingDimension.values.splice(index, 1);
        }
        break;
      default:
        break;
    }
    return {
      data: change.data,
      keyExpr: "value",
    };
  };

  const editorItemOptions = useMemo(() => new Map<string, IItemProps>([
    [
      "value",
      {
        editorType: "dxSelectBox",
        editorOptions: {
          items: props.availableValues || [],
          searchEnabled: true,
        },
      },
    ],
  ]), [props.availableValues]);

  return (
    <CrudDataGrid
      pageProps={props.pageProps}
      logger={props.logger}
      dummyRow={dummyArmMappingDimensionValueRow}
      keyExpr={"value"}
      formTitle="Add Value"
      formColCount={2}
      formColSpan={2}
      refreshData={refreshValueData}
      allowAdding={true}
      allowUpdating={false}
      allowDeleting={true}
      filterRowDataForForm={filterValueRowDataForForm}
      sendChange={sendValueChange}
      hideColumnChooser={true}
      hideSearchPanel={true}
      hideInactiveButton={true}
      columnConfigs={armMappingDimensionValueColumns}
      editorItemOptions={editorItemOptions}
    ></CrudDataGrid>
  );
};
